import { useTheme } from '../useTheme'

const leftAccent = props => {
  const { color } = props
  return {
    pl: 3,
    ...subtle(props),
    borderLeft: '4px',
    borderColor: `${color}.500`,
  }
}

const topAccent = props => {
  const { color } = props
  return {
    pt: 2,
    ...subtle(props),
    borderTop: '4px',
    borderColor: `${color}.500`,
  }
}

const solid = ({ color }) => {
  return { bg: `${color}.500`, color: 'white' }
}

const subtle = ({ color, theme: { colors } }) => {
  return { bg: `${color}.100` }
}

const statusStyleProps = props => {
  switch (props.variant) {
    case 'solid':
      return solid(props)
    case 'subtle':
      return subtle(props)
    case 'top-accent':
      return topAccent(props)
    case 'left-accent':
      return leftAccent(props)
    default:
      return {}
  }
}

const baseProps = {
  display: 'flex',
  alignItems: 'center',
  overflow: 'hidden',
  pl: 4,
  pr: 4,
  pt: 3,
  pb: 3,
}

export const useAlertIconStyle = ({ variant, color }) => {
  if (['left-accent', 'top-accent', 'subtle'].includes(variant)) {
    return { color: `${color}.500` }
  }
}

export const useAlertStyle = props => {
  const theme = useTheme()
  const _props = { ...props, theme }

  return {
    ...baseProps,
    ...statusStyleProps(_props),
  }
}

export default useAlertStyle
